define('modules/ads/ads_filter_model',['backbone', '_', 'session'], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      adsPeriod: 'all',
      playerOptions: null,
      zoneOptions: null,
      bookingTypeOptions: null,
      searchText: '',
    },
    parse: function (data) {
      return {
        zoneOptions: {
          active: [],
          options: data.zoneOptions,
        },
        playerOptions: {
          active: [],
          options: data.playerOptions,
        },
        bookingTypeOptions: {
          active: [],
          options: data.bookingTypeOptions
        },
        searchText: data.searchText || '',
      };
    },
    url: function () {
      return session.get('apiUrl') + 'htmladlocation/filteroptions';
    },
  });

  return Model;
});

